import axios from 'axios';

const cabine = axios.create({
  baseURL: process.env.REACT_APP_CABINE_URL,
});

export default cabine;
